'use client';

const SESSION_KEY = 'listingNavState';
const MAX_AGE_MS = 30 * 60 * 1000; // 30 min

interface ListingNavState {
  listUrl: string;
  objectId: string;
  timestamp: number;
}

export function writeListingNavState(listUrl: string, objectId: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ listUrl, objectId, timestamp: Date.now() }),
    );
  } catch {
    // sessionStorage unavailable (private mode quota, etc.) — silently skip
  }
}

export function clearListingNavState(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // sessionStorage unavailable — silently skip
  }
}

export function readListingNavState(): ListingNavState | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const state = JSON.parse(raw) as ListingNavState;
    if (Date.now() - state.timestamp > MAX_AGE_MS) return null;
    return state;
  } catch {
    return null;
  }
}
